import { createCustomEvent } from "../../../../javascript/shared/helpers"

export default class extends Controller {
  connect() {
    document.dispatchEvent(createCustomEvent("primary-content-pane-load:trigger", this.element, {
      contentURL: this.contentURL,
      contentTitle: this.contentTitle
    }))
  }

  get contentURL() {
    return this.data.get("content-url")
  }

  get contentTitle() {
    return this.data.get("content-title")
  }
}



// WEBPACK FOOTER //
// ./app/components/my_via/assets/javascript/my-via-dashboard-loader-controller.js